import { createSelector } from 'reselect';

import type { State } from 'reducers';

import { type CampaignPageState, initialState } from './reducer';

const selectState = (state: State): CampaignPageState => state.get('campaignPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));
export const selectError = createSelector(selectState, (state) => state.get('error'));
